import { query } from '@/utils/request';

/**
 * 运营侧-敏感词记录查询
 * @param params 
 * @returns 
 */
export async function fetchSensitiveWordList (params) {
  return query('/zlb/api/expense/sensitive-word/operation/paging', {
    params,
  });
}